/* global $:false */

export default class MarketLotShowBidHistoryExpansion {
  static init () {
    Array.from($('.js-market-lot-show-expand-bid-history')).map((el) =>
      new MarketLotShowBidHistoryExpansion(el))
  }

  constructor (el) {
    this.el = $(el)
    this.setupBindings()
  }

  setupBindings () {
    this.el.click(event => {
      event.preventDefault()
      // Bids are continuously generated, let's read them afresh.
      const bids = $('.js-market-lot-show-bids')
      bids.show()
      this.el.remove()
    })
  }
}
